// extracted by mini-css-extract-plugin
module.exports = {"introContainer":"Intro_introContainer__c2bZK","headline":"Intro_headline__DqHJH","highlight":"Intro_highlight__1pUwm","strap":"Intro_strap__21Eql"};